"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryStatus = exports.TransactionType = exports.GradingStatus = exports.GradingCompany = exports.CardLanguage = exports.CardRarity = exports.CardCondition = void 0;
// Core enums and constants
var CardCondition;
(function (CardCondition) {
    CardCondition["MINT"] = "MINT";
    CardCondition["NEAR_MINT"] = "NEAR_MINT";
    CardCondition["LIGHTLY_PLAYED"] = "LIGHTLY_PLAYED";
    CardCondition["MODERATELY_PLAYED"] = "MODERATELY_PLAYED";
    CardCondition["HEAVILY_PLAYED"] = "HEAVILY_PLAYED";
    CardCondition["DAMAGED"] = "DAMAGED";
})(CardCondition = exports.CardCondition || (exports.CardCondition = {}));
var CardRarity;
(function (CardRarity) {
    CardRarity["COMMON"] = "COMMON";
    CardRarity["UNCOMMON"] = "UNCOMMON";
    CardRarity["RARE"] = "RARE";
    CardRarity["RARE_HOLO"] = "RARE_HOLO";
    CardRarity["ULTRA_RARE"] = "ULTRA_RARE";
    CardRarity["SECRET_RARE"] = "SECRET_RARE";
    CardRarity["PROMO"] = "PROMO";
})(CardRarity = exports.CardRarity || (exports.CardRarity = {}));
var CardLanguage;
(function (CardLanguage) {
    CardLanguage["ENGLISH"] = "EN";
    CardLanguage["JAPANESE"] = "JP";
    CardLanguage["GERMAN"] = "DE";
    CardLanguage["FRENCH"] = "FR";
    CardLanguage["ITALIAN"] = "IT";
    CardLanguage["SPANISH"] = "ES";
    CardLanguage["KOREAN"] = "KO";
    CardLanguage["CHINESE_TRADITIONAL"] = "ZH-TW";
    CardLanguage["CHINESE_SIMPLIFIED"] = "ZH-CN";
})(CardLanguage = exports.CardLanguage || (exports.CardLanguage = {}));
var GradingCompany;
(function (GradingCompany) {
    GradingCompany["PSA"] = "PSA";
    GradingCompany["BGS"] = "BGS";
    GradingCompany["CGC"] = "CGC";
    GradingCompany["SGC"] = "SGC";
})(GradingCompany = exports.GradingCompany || (exports.GradingCompany = {}));
var GradingStatus;
(function (GradingStatus) {
    GradingStatus["RAW"] = "RAW";
    GradingStatus["SUBMITTED"] = "SUBMITTED";
    GradingStatus["IN_GRADING"] = "IN_GRADING";
    GradingStatus["GRADED"] = "GRADED";
})(GradingStatus = exports.GradingStatus || (exports.GradingStatus = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["PURCHASE"] = "PURCHASE";
    TransactionType["SALE"] = "SALE";
    TransactionType["TRADE"] = "TRADE";
    TransactionType["GRADING_SUBMISSION"] = "GRADING_SUBMISSION";
    TransactionType["GRADING_RETURN"] = "GRADING_RETURN";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var InventoryStatus;
(function (InventoryStatus) {
    InventoryStatus["OWNED"] = "OWNED";
    InventoryStatus["SOLD"] = "SOLD";
    InventoryStatus["AT_GRADING"] = "AT_GRADING";
    InventoryStatus["LOST"] = "LOST";
    InventoryStatus["TRADED"] = "TRADED";
})(InventoryStatus = exports.InventoryStatus || (exports.InventoryStatus = {}));
